export default "{\n    \"error\": \"IconButton: Unable to find tracking label, please provide a trackingLabel prop\"\n}\n"